import { MAIN_PORTAL_INSTANCE_ID } from "@productlane/lib/src/portal-instance"

export interface PendingProjectRow {
	portalInstanceIds?: readonly string[] | string[] | null
	linearTeamIds?: readonly string[] | string[] | null
}

export function countPendingProjects(
	projects: readonly PendingProjectRow[] | undefined,
	{
		multiPortalActive,
		activePortalInstanceId,
		selectedTeamIds,
	}: {
		multiPortalActive: boolean
		activePortalInstanceId: string | null
		selectedTeamIds: readonly string[]
	},
) {
	return (
		projects?.filter((project) => {
			if (multiPortalActive) {
				const ids = project.portalInstanceIds ?? []
				const matchesPortal =
					activePortalInstanceId === null
						? ids.length === 0 || ids.includes(MAIN_PORTAL_INSTANCE_ID)
						: ids.includes(activePortalInstanceId)
				if (!matchesPortal) return false
			}
			if (selectedTeamIds.length > 0) {
				if (!project.linearTeamIds?.some((id) => selectedTeamIds.includes(id)))
					return false
			}
			return true
		}).length ?? 0
	)
}
